import { render } from "./BaseCustomMessage.vue?vue&type=template&id=58841e14&scoped=true"
import script from "./BaseCustomMessage.vue?vue&type=script&lang=js"
export * from "./BaseCustomMessage.vue?vue&type=script&lang=js"

import "./BaseCustomMessage.vue?vue&type=style&index=0&id=58841e14&lang=scss&scoped=true"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58841e14"]])

export default __exports__